import { Skeleton, Stack } from "@mui/material";

export default function SeverityBarIndicatorSkeleton() {
	return (
		<Stack spacing={0.75} alignSelf={"center"}>
			<Skeleton variant={"text"} width={80} className="rounded-md !h-3" />
			<Skeleton variant="rectangular" width={525} className="rounded-md !h-3" />
			<Stack direction="row" justifyContent="space-between" className="w-full">
				<Skeleton variant={"text"} width={40} className="rounded-md !h-3 pl-1.5" />
				<Skeleton variant={"text"} width={40} className="rounded-md !h-3 pr-1.5" />
			</Stack>
		</Stack>
	);
}
